<template>
  <basic-container>
    <avue-crud :option="option" :data="data" :page.sync="page" ref="crud" @row-del="rowDel" v-model="form"
      :permission="permissionList" @row-update="rowUpdate" @row-save="rowSave" :before-open="beforeOpen"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange"
      @selection-change="selectionChange" @on-load="onLoad"  :header-cell-class-name="headerCellClassName">
      <template slot="menuLeft">
        <el-button type="danger" size="small" icon="el-icon-delete" plain v-if="permission.qa_qa_delete"
          @click="handleDelete">删 除
        </el-button>
      </template>
      <!-- <template slot-scope="scope" slot="menu">
        <el-button type="text" icon="el-icon-s-operation" size="small" @click.native="toItem(scope.row)">内容编辑
        </el-button>
      </template> -->
    </avue-crud>
  </basic-container>
</template>

<script>
import { getListTypeTemplateDetails, submitDetails, removeDetails, getDetail } from '@/api/sys/cookbook'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      params: [],
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        addBtn: false,
        editBtn: false,
        addRowBtn: true,
        cellBtn: true,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        menuWidth: 300,
        column: [
          {
            label: '食谱名称',
            prop: 'recipeName',
            cell: false
          },
          {
            label: '类型名称',
            prop: 'typeName',
            cell: false
          },
          {
            label: '食谱详情',
            prop: 'details',
            cell: true,
            rules: [{
              required: true,
              message: '请输入食谱详情'
            }]
          },
          {
            label: '创建时间',
            prop: 'createTime',
            cell: false
          },
          {
            label: '修改时间',
            prop: 'updateTime',
            cell: false
          }
        ]
      },
      data: []
    }
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList () {
      return {
        addBtn: this.permission.qa_qa_add,
        viewBtn: this.permission.qa_qa_view,
        delBtn: this.permission.qa_qa_delete,
        editBtn: this.permission.qa_qa_edit
      }
    },
    ids () {
      const ids = []
      this.selectionList.forEach(ele => {
        ids.push(ele.id)
      })
      return ids.join(',')
    }
  },
  created () {
    this.params.parentRecipeId = this.$route.query.parentRecipeId
    this.params.type = this.$route.query.type
    this.params.typeName = this.$route.query.typeName
    this.params.recipeName = this.$route.query.recipeName
    this.params.isUsing = '1'
  },
  methods: {
    // toItem (row) {
    //   this.$router.push({
    //     path: '/sys/cookbookType',
    //     query: {
    //       parentRecipeId: row.id,
    //       id: row.id
    //     }
    //   })
    // },
    rowSave (row, done, loading) {
      row.isUsing = '1'
      row.parentRecipeId = this.params.parentRecipeId
      row.type = this.params.type
      row.typeName = this.params.typeName
      row.recipeName = this.params.recipeName
      row.wxUserId = '0'
      submitDetails(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowUpdate (row, index, done, loading) {
      submitDetails(row).then(() => {
        done()
        this.onLoad(this.page)
        this.$message({
          type: 'success',
          message: '操作成功!'
        })
      }).catch(() => {
        loading()
      })
    },
    rowDel (row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return removeDetails(row.id)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
        })
    },
    searchReset () {
      this.onLoad(this.page)
    },
    searchChange (params, done) {
      this.onLoad(this.page, params)
      done()
    },
    selectionChange (list) {
      this.selectionList = list
    },
    refreshChange (data) {
      this.onLoad(this.page, data.searchForm)
    },
    handleDelete () {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据')
        return
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          return removeDetails(this.ids)
        })
        .then(() => {
          this.onLoad(this.page)
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.$refs.crud.toggleSelection()
        })
    },
    beforeOpen (done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data
        })
      }
      done()
    },
    onLoad () {
      getListTypeTemplateDetails(this.params).then(res => {
        const data = res.data
        this.data = data
        console.log('测试')
        console.log(res)
      })
    }
  }
}
</script>
<style>
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
